import {
  compose,
  filter,
  fromPairs,
  isEmpty,
  map,
  prop,
  toPairs,
  toUpper,
} from 'ramda';
import { replace } from 'yafrpl/strings';

import { clear, unprefix } from '../../../helpers/compact';
import { toText } from './text';

const transformKey = replace(/[-_][a-z]/g, (val: string): string =>
  toUpper(val[1])
);

export type Thumbnail = {
  src?: string;
  width?: number;
  height?: number;
};

export type Image = {
  src?: string;
  alt?: string;
  copyright?: string;
  thumbnail?: Thumbnail;
  width?: number;
  height?: number;
};

const thumb = ({
  url,
  dimensions: { width, height } = {},
  ...rest
}: {
  url: string;
  dimensions: Record<string, number>;
}): Thumbnail =>
  clear({
    ...rest,
    src: url,
    width: width,
    height: height,
  });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const thumbs: (val: any) => Record<string, Thumbnail> = compose(
  fromPairs,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filter<any>(Boolean),
  map(([key, value]) => {
    const normalized = thumb(value);
    return !isEmpty(normalized) && [transformKey(key), normalized];
  }),
  toPairs,
  unprefix('thumb')
);

export const toImage = ({
  url,
  alt,
  dimensions,
  copyright,
  ...rest
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any = {}): Image => {
  if (url) {
    return clear({
      src: url,
      alt: toText(alt),
      copyright: toText(copyright),
      thumbnail: thumbs(rest),
      width: dimensions?.width,
      height: dimensions?.height,
    });
  }
};

export const toImageFromProp = compose(toImage, prop);
